<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/problem' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>不良件货库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <!--<el-input
                    placeholder="请输入内容"
                    clearable
                    v-model="queryInfo.userName"
                    size="small"
                    @keyup.enter.native="searchList"
                >
                </el-input>-->
                <search-user-id v-model="queryInfo.userName"></search-user-id>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input
                    placeholder="请输入内容"
                    clearable
                    v-model="queryInfo.orderNo"
                    size="small"
                    @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">创建开始日:</div>
              <div class="flex1">
                <el-date-picker
                    clearable
                    v-model="queryInfo.createTimeStart"
                    type="date"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">创建结束日:</div>
              <div class="flex1">
                <el-date-picker
                    clearable
                    v-model="queryInfo.createTimeEnd"
                    type="date"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>

          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">处理方式:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.handleType" placeholder="请选择" size="small" clearable>
                  <el-option key="" value="" label="全部"></el-option>
                  <el-option key="1" value="1" label="换货"></el-option>
                  <el-option key="2" value="2" label="补发"></el-option>
                  <el-option key="3" value="3" label="部分退货"></el-option>
                  <el-option key="4" value="4" label="全部退货"></el-option>
                  <el-option key="5" value="5" label="部分销毁"></el-option>
                  <el-option key="6" value="6" label="全部销毁"></el-option>
                  <el-option key="7" value="7" label="正常发送"></el-option>
                </el-select>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">不良件状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.handleState" placeholder="请选择" size="small" clearable>
                  <el-option key="1" value="1" label="待处理"></el-option>
                  <el-option key="2" value="2" label="处理中"></el-option>
                  <el-option key="3" value="3" label="处理完"></el-option>
                  <el-option key="4" value="4" label="已取消"></el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title">处理开始日:</div>
              <div class="flex1">
                <el-date-picker
                    clearable
                    v-model="queryInfo.handleTimeStart"
                    type="date"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">处理结束日:</div>
              <div class="flex1">
                <el-date-picker
                    clearable
                    v-model="queryInfo.handleTimeEnd"
                    type="date"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">重发运单号:</div>
              <div class="flex1">
                <el-input
                    placeholder="请输入内容"
                    clearable
                    v-model="queryInfo.waybillNumber"
                    size="small"
                    @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">发回运单号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.returnWaybillNo"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">客户名:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.customerName"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">购买订单号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.buyOrderNumber"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <!-- <el-col :span="12" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col> -->
        </el-row>
        </el-collapse>
        <el-row  class="search-row">
          <el-col :span="18" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === ''}" @click="changeTab('')">全部</el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}" @click="changeTab(1)">待处理<span class="lx-red">({{problemCount.waitNum}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}" @click="changeTab(2)">处理中<span class="lx-red">({{problemCount.handlingNum}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}" @click="changeTab(3)">处理完<span class="lx-red"></span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 4}" @click="changeTab(4)">已取消<span class="lx-red"></span></el-button>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-blue" @click="exportAction">导出</el-button>
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="toSort"
              >排序</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="messageList"
            v-loading="isLoading"
            border
            height="550"
        >
          <el-table-column
              v-for="(item, index) in asyncColumns"
              :key="index"
              align="center"
              :label="item.name"
              :prop="item.key"
              :width="item.width?item.width:'auto'"
              :min-width="item.minWidth?item.minWidth:'auto'"
            >
              <template v-slot="scope">
                  <!-- 操作 -->
                <div v-if="item.key === 'handle'" style="display: inline-block" class="btn-row">
                  <el-button class="list-btn btn-blue" @click="toProblemDetail(scope.row)">详情</el-button>
                  <el-button v-if="scope.row.handleState == '2'" class="list-btn btn-green" @click="handleBad(scope.row)">处理</el-button>
                </div>
                <!-- 处理方式 -->
                <div v-else-if="item.key === 'handleType'">
                  <div v-if="scope.row.handleState=='1'">
                      <el-button
                          class="list-btn-four btn-green"
                          @click="handle(scope.row,1)"
                      >
                        换货
                      </el-button>
                      <el-button
                          class="list-btn-four btn-green"
                          @click="handle(scope.row,2)"
                      >
                        补发
                      </el-button>
                      <el-button
                          class="list-btn-four btn-deepblue"
                          @click="handle(scope.row,3)"
                      >
                        部分退货
                      </el-button>
                      <el-button
                          class="list-btn-four btn-deepblue"
                          @click="handle(scope.row,4)"
                      >
                        全部退货
                      </el-button>
                      <el-button
                          class="list-btn-four btn-blue"
                          @click="handle(scope.row,5)"
                      >
                        部分销毁
                      </el-button>
                      <el-button
                          class="list-btn-four btn-blue"
                          @click="handle(scope.row,6)"
                      >
                        全部销毁
                      </el-button>
                      <el-button
                          class="list-btn-four btn-green"
                          @click="send(scope.row)"
                      >
                        正常发送
                      </el-button>
                  </div>
<!--                  <div v-if="scope.row.handleState=='2'">-->
<!--                    <div v-if="scope.row.handleType=='3' || scope.row.handleType=='4'">-->
<!--                        <el-button-->
<!--                            class="list-btn-four btn-green"-->
<!--                            @click="cannelBill(scope.row,'退货',8)"-->
<!--                        >-->
<!--                          取消退货-->
<!--                        </el-button>-->
<!--                    </div>-->
<!--                  <div v-if="scope.row.handleType=='5' || scope.row.handleType=='6'">-->
<!--                        <el-button-->
<!--                            class="list-btn-four btn-green"-->
<!--                            @click="cannelBill(scope.row,'销毁',9)"-->
<!--                        >-->
<!--                          取消销毁-->
<!--                        </el-button>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div v-if="scope.row.handleState=='3' || scope.row.handleState=='2'">
                    <div v-for="(item,index) in handleTypeOptions" :key="index">
                      <div v-if="item.value==scope.row.handleType && scope.row.handleState!='1'">
                        {{item.label}}
                        <el-button v-if="scope.row.handleState=='2'"
                            class="list-btn-four btn-gray"
                            @click="cancelStatus(scope.row)"
                        >
                          状态撤回
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 创建时间 -->
                <div v-else-if="item.key === 'createTime'">
                  {{ scope.row.createTime | formatDateFilter }}
                </div>
                <!-- 商品数量 -->
              <div v-else-if="item.key === 'goodsInfo'" >
                <div class="lx-text-left">
                  <span>单价：</span>
                  <span>{{scope.row.price}}</span>
                </div>
                <div class="lx-text-left">
                  <span>颜色：</span>
                  <span>{{scope.row.colour}}</span>
                </div>
                <div class="lx-text-left">
                  <span>尺寸：</span>
                  <span>{{scope.row.goodsSize}}</span>
                </div>
                <div class="lx-text-left">
                  <span>品番：</span>
                  <span>{{scope.row.goodsNumber}}</span>
                </div>
                <div class="lx-text-left">
                  <span>购买订单号：</span>
                  <span>{{scope.row.buyOrderNumber}}</span>
                </div>
                <div class="lx-text-left">
                  <span>购买账号：</span>
                  <el-select
                  v-model="scope.row.buyAccountId"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in buyAcountList"
                    :key="item.id"
                    :label="item.platformType_hanzi"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                </div>
                <div class="lx-text-left">
                  <span>检品人：</span>
                  <span>{{scope.row.checkUserName}}</span>
                </div>
              </div>
                <!-- 图片 -->
                <div v-else-if="item.key === 'problemUrl'">
                  <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.miniUrl4&&scope.row.miniUrl4.length>0" :src="scope.row.miniUrl4" alt=""
                    class="list-image">
                  <img v-else src="@/assets/images/default.png" alt="" class="list-image">
                  <div class="btn-row">
                    <el-button
                        class="list-btn-four btn-blue"
                        @click="toGoodsDetail(scope.row)"
                    >
                      商品详情
                    </el-button>
                  </div>
                </div>
                <!-- 不良图片 -->
                <div v-else-if="item.key === 'problemImg'">
                  <img @click="imgclick(scope.row.problemUrl1,true)" v-if="scope.row.miniUrl1&&scope.row.miniUrl1.length>0" :src="scope.row.miniUrl1" alt=""
                    class="list-image" style="width: 60px;height: 60px;">
                  <img v-else src="@/assets/images/default.png" alt="" class="list-image"
                    style="width: 60px;height: 60px;">
                  <img @click="imgclick(scope.row.problemUrl2,true)" v-if="scope.row.miniUrl2&&scope.row.miniUrl2.length>0" :src="scope.row.miniUrl2" alt=""
                    class="list-image" style="width: 60px;height: 60px;">
                  <img v-else src="@/assets/images/default.png" alt="" class="list-image"
                    style="width: 60px;height: 60px;">
                  <img @click="imgclick(scope.row.problemUrl3,true)" v-if="scope.row.miniUrl3&&scope.row.miniUrl3.length>0" :src="scope.row.miniUrl3" alt=""
                    class="list-image" style="width: 60px;height: 60px;">
                  <img v-else src="@/assets/images/default.png" alt="" class="list-image"
                    style="width: 60px;height: 60px;">
                </div>
                <!-- 不良数量 -->
                <div v-else-if="item.key === 'brokenCount'">
                  <div>
                    <span class="table-cell-title-mid">破损：</span>
                    <span style="margin-left: -24px">{{ scope.row.brokenCount }}</span>
                  </div>
                  <div>
                    <span class="table-cell-title-mid">脏污：</span>
                    <span style="margin-left: -24px">{{ scope.row.dirtCount }}</span>
                  </div>
                  <div>
                    <span class="table-cell-title-mid">错款：</span>
                    <span style="margin-left: -24px">{{ scope.row.designCount }}</span>
                  </div>
                  <div>
                    <span class="table-cell-title-mid">少数：</span>
                    <span style="margin-left: -24px">{{ scope.row.insufficientCount }}</span>
                  </div>
                </div>
                <!-- 处理说明 -->
                <div v-else-if="item.key === 'handleDescription'">
                  <p style="font-size: 14px!important;max-height: 100px;overflow-y: auto">{{ scope.row.handleDescription }}</p>
                  <p style="font-size: 14px!important;">{{scope.row.handleTime | dateFormatToSecond}}</p>
                  <div class="btn-row">
                    <el-button class="list-btn btn-blue" @click="problemAll(scope.row)">全部</el-button>
                    <el-button class="list-btn btn-blue" @click="addProblem(scope.row)">添加</el-button>
                  </div>
                </div>
                <!-- 处理状态 -->
                <div v-else-if="item.key === 'handleState'">
                  {{ typeDetailShow(scope.row.handleState) }}
                </div>
                <!-- 创建时间 -->
                <div v-else-if="item.key === 'handleTime'">
                  {{ scope.row.handleTime | formatDateFilter }}
                </div>
                <!-- 发回运单号 -->
                <div v-else-if="item.key === 'returnWaybillNo'">
                  <el-input
                    v-model="scope.row.returnWaybillNo"
                    size="mini"
                    @blur="updateNotes(scope.row,1)"
                  />
                </div>
                <!-- 重发运单号 -->
                <div v-else-if="item.key === 'waybillNumber'">
                  <el-input
                    v-model="scope.row.waybillNumber"
                    size="mini"
                    @blur="updateNotes(scope.row,2)"
                  />
                </div>
                <!-- 退货地址 -->
                <div v-else-if="item.key === 'returnAddress'">
                  <el-input
                    v-model="scope.row.returnAddress"
                    size="mini"
                    @blur="updateNotes(scope.row,3)"
                  />
                </div>
                <!-- 其他不需要处理的 -->
                <span v-else>
                  {{scope.row[item.key]}}
                </span>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 不良处理 -->
    <el-dialog
        :title="title"
        :visible.sync="replyDialogVisible"
        width="50%"
        @close="replyDialogClose"
    >
      <el-form :model="replyInfos" :rules="rules" ref="replyInfoRef" label-width="120px" class="demo-replyInfo">
        <div style="display: none">
          <el-form-item label="id：" prop="id">
            <el-input
                v-model="replyInfos.id"
                size="small"
                style="width: 90%"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1">
          <el-form-item label="换货数量：" prop="exchangeCount">
            <el-input
                v-model="replyInfos.exchangeCount"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 3">
          <el-form-item label="退货数量" prop="returnCount">
            <el-input
                v-model="replyInfos.returnCount"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 4">
          <el-form-item label="退货数" prop="returnCount">
            <el-input
                v-model="replyInfos.returnCount"
                size="small"
                style="width: 90%"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1 || handleflag == 3 || handleflag == 4">
          <el-form-item label="退货运费：" prop="returnFee">
            <el-input
                v-model="replyInfos.returnFee"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 2">
          <el-form-item label="补发数量" prop="reissueCount">
            <el-input
                v-model="replyInfos.reissueCount"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1 || handleflag == 2">
          <el-form-item label="重发运单号：" prop="waybillNumber">
            <el-input
                v-model="replyInfos.waybillNumber"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 5">
          <el-form-item label="销毁数量" prop="destroyCount">
            <el-input
                v-model="replyInfos.destroyCount"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 6">
          <el-form-item label="销毁数" prop="destroyCount">
            <el-input
                v-model="replyInfos.destroyCount"
                size="small"
                style="width: 90%"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 3 || handleflag == 4">
          <el-form-item label="退货地址" prop="returnAddress">
            <el-input
                v-model="replyInfos.returnAddress"
                size="small"
                style="width: 90%"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="clearReplyForm">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="handleSave">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="正常发送"
        :visible.sync="sendDialogVisible"
        width="50%"
        @close="sendDialogClose"
    >
      <el-form :model="sendInfos" label-width="120px" class="demo-replyInfo">
        <div style="display: none">
          <el-form-item label="id：" prop="id">
            <el-input
                v-model="sendInfos.id"
                size="small"
                style="width: 90%"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div style="display: none">
          <el-form-item label="orderNo：" prop="orderNo">
            <el-input
                v-model="sendInfos.orderNo"
                size="small"
                style="width: 90%"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div>
          选择正常发货后，意味着用户接受不良品发送到目的地，主订单状态会变为不良驳回状态，不良件订单会变为处理中状态。
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="clearSendForm">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="sendSave">提 交</el-button>

      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog
        title=""
        :visible.sync="visible"
        width="30%"
        show-close
        center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 添加说明 -->
    <el-dialog
    title="添加说明"
    width="600px"
    center
    @close="cancel('replyInfo')"
    :visible.sync="addVisible"
    >
      <el-form :model="problemData" :rules="rules" ref="replyInfo" label-width="100px" class="demo-replyInfo">
        <div class="inputBox">
          <el-form-item prop="content" label="处理说明">
            <el-input type="textarea" resize="none" :rows="3" v-model="problemData.content"></el-input>

          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('replyInfo')">取消</el-button>
        <el-button type="primary" @click="saveExplain('replyInfo')">提交</el-button>
      </div>
    </el-dialog>
        <!-- 处理说明 -->
    <el-dialog
    title="处理说明"
    width="800px"
    center
    :visible.sync="dialogVisible"
    >
      <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="items"
        border
        height="450px"
      >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>\
        <el-table-column
          align="center"
          prop="createUserRealName"
          label="添加人"
          width="120"
        >
          <template v-slot="scope">
            {{ scope.row.createUserRealName }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          width="120"
          label="添加时间"
        >
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="content"
          label="内容"
        >
          <template v-slot="scope">
            {{ scope.row.content }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 不良处理 -->
    <el-dialog :title="badDialogTitle" width="600px" center :visible.sync="badVisible">
      <el-form :model="bad" ref="bad" :rules="badRules"label-width="100px" class="demo-replyInfo">
        <div class="inputBox">
          <el-form-item label="物流公司：" prop="logisticsCompanyId" label-width="120px" v-if="problem.orderStatus != '32' && problem.orderStatus != '40' && problem.handleType != '5' && problem.handleType != '6' && problem.handleType != '7'">
            <el-select v-model="bad.logisticsCompanyId" placeholder="请选择" size="small" clearable>
              <el-option v-for="item in LogisticsCompanyList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="trackingNumber" label="运单号" label-width="120px" v-if="problem.orderStatus != '32' && problem.orderStatus != '40' && problem.handleType != '5' && problem.handleType != '6' && problem.handleType != '7'">
            <el-input size="small" v-model="bad.trackingNumber"></el-input>
          </el-form-item>

          <el-form-item prop="returnFee" label="退货运费" label-width="120px" v-if="problem.orderStatus != '32' && problem.orderStatus != '40' && problem.handleType != '5' && problem.handleType != '6' && problem.handleType != '7'">
            <el-input size="small" v-model="bad.returnFee"></el-input>
          </el-form-item>

          <el-form-item label="库位：" prop="configLocatorId" label-width="120px" v-if="problem.orderStatus != '28' && problem.handleType != '4'">
            <el-select v-model="bad.configLocatorId" placeholder="请选择" size="small" clearable>
              <el-option
                  v-for="item in dropDownList"
                  :key="item.id"
                  :label="item.locatorNo"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="badVisible=false">取消</el-button>
        <el-button type="primary" @click="submitBad">提交</el-button>
      </div>
    </el-dialog>

    <lx-sort
      :visible.sync="isVisibleSort"
      :list="columns"
      @confirm="doSaveColumns"
    ></lx-sort>
  </div>
</template>

<script>
import { columns as originColumns } from "./problemColumns";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import tableCon from "../../views/tableContainer";


export default {
  components: {
    LxSort,
    tableCon,
  },
  name: 'problem',
  data() {
    return {
      badDialogTitle:'不良件处理',
      problem:{
        orderDetailId:0,
        //1换货2补发3部分退货4全部退货5部分销毁6全部销毁7正常发送
        handleType:'',
        //订单状态1待购买2购买完0等待到库4到库8检品中12检品完16仓库保管中20申请发货24不良待处理26不良驳回28换货待发回32换货等待到货36待部分退货40补发等待到货44待支付48待发送52已发送56已取消60退货申请中64退货待支付68待退货72已退货76销毁申请中80销毁待支付82待部分销毁84已销毁88装箱中89无法购买
        orderStatus:''
      },
      bad:{
        orderId:'',
        //库位ID
        configLocatorId:'',
        //物流公司
        logisticsCompanyId:'',
        //运单号
        trackingNumber:'',
        //退货运费
        returnFee:0,
      },
      //物流公司下拉选
      LogisticsCompanyList:[],
      //库位的下拉列表
      dropDownList: [],
      badVisible:false,
      isActive:false,
      buyAcountList: [],
      curIndex: '',
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      orderList: [],
      menuSettingData: {
        menuId: 'staffProblem'
      },
      visible:false,
      imgurl:'',
      title: '',
      handleflag: 1,
      replyInfos: {
        returnAddress:'',
      },
      sendInfos: {
        id: '',
        orderNo: ''
      },
      rules: {
        exchangeCount: [
          {required: true, message: '换货数量不能为空', trigger: 'blur'}
        ],
        reissueCount: [
          {required: true, message: '补发数量不能为空', trigger: 'blur'}
        ],
        returnCount: [
          {required: true, message: '退货数量不能为空', trigger: 'blur'}
        ],
        destroyCount: [
          {required: true, message: '销毁数量不能为空', trigger: 'blur'}
        ],
        content:[
          {required:true,message:'处理说明不能为空',trigger:'blur'}
        ]
      },
      badRules:{
        configLocatorId: [
          {required: true, message: '库位不能为空', trigger: 'blur'}
        ],
        logisticsCompanyId: [
          {required: true, message: '物流公司不能为空', trigger: 'blur'}
        ],
        trackingNumber: [
          {required: true, message: '运单号不能为空', trigger: 'blur'}
        ],
        returnFee: [
          {required: true, message: '退货运费不能为空', trigger: 'blur'}
        ]
      },
      queryInfo: {
        userName: '',
        orderNo: '',
        handleType: '',
        handleState: '',
        returnWaybillNo: '',
        waybillNumber: '',
        createTimeStart: '',
        createTimeEnd: '',
        customerName:'',
        buyOrderNumber:'',
        handleTimeStart: '',
        handleTimeEnd: '',
        brokenCount: '',
        pageSize: 10,
        pageNum: 1
      },
      problemCount:{
        total:0,
        waitNum:0,
        handlingNum:0,
        finishNum:0,
        cancelNum:0
      },
      badDateRangeValue: [],
      problemDateRangeValue: [],
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      messageInfo: {
        id: '',
        remindingContent: '',
        remindingTitle: '',
        remindingPicture: ''
      },    //回复新的内容
      messageTypeOptions: [
        {
          value: '1',
          label: '订单消息'
        }, {
          value: '2',
          label: '其他消息'
        }
      ],
      replyStatusOptions: [
        {
          value: '0',
          label: '未回复'
        }, {
          value: '1',
          label: '已回复'
        }
      ],
      messageList: [],
      dialogFormVisible: false,
      replyDialogVisible: false,
      sendDialogVisible: false,
      total: 0,

      addVisible:false,
      problemData:{}, //添加处理说明
      items:[],       //处理说明列表
      // dialogVisible:false,
      handleTypeOptions: [
        {value: "1", label: "换货"},
        {value: "2", label: "补发"},
        {value: "3", label: "部分退货"},
        {value: "4", label: "全部退货"},
        {value: "5", label: "部分销毁"},
        {value: "6", label: "全部销毁"},
        {value: "7", label: "正常发送"}
      ],
    }
  },
  created() {
    this.getAsyncColumns().then(() => {
      this.getProblemCount();
      this.getProblemList();
      this.getBuyAccountIdList();
      this.getLocatorDropDownList();
      this.getDropDownList();
    });
  },
  methods: {
    submitBad(){
      this.$refs['bad'].validate(async (valid) => {
        if (valid) {
          const {data: res} = await this.$http.post('orderStatus/handle', this.bad)
          if (res.code == 200) {
            this.$message({
              message: '处理成功',
              type: 'success'
            })
            this.getProblemCount();
            this.getProblemList();
            this.badVisible =false;
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
    handleBad(row){
      this.problem = row
      Object.assign(this.bad,this.problem)
      this.bad.id = this.problem.orderDetailId
      this.bad.orderId = this.problem.orderNo
      this.bad.configLocatorId = ''
      this.bad.logisticsCompanyId = ''
      this.bad.trackingNumber = ''

      //处理时的退货运费取之前的
      if(this.problem.returnFee!=null&&this.problem.returnFee!=undefined){
        this.bad.returnFee = this.problem.returnFee;
      }else {
        this.bad.returnFee = 0
      }

      if (this.problem.orderStatus == '26'){
        this.badDialogTitle = '不良件处理-关闭不良'
      }
      if (this.problem.orderStatus == '28'){
        this.badDialogTitle = '不良件处理-换货发回'
      }
      if (this.problem.orderStatus == '32'){
        this.badDialogTitle = '不良件处理-换货到库'
      }
      if (this.problem.orderStatus == '36'){
        this.badDialogTitle = '不良件处理-部分退货'
      }
      if (this.problem.orderStatus == '40'){
        this.badDialogTitle = '不良件处理-补发到货'
      }
      if (this.problem.orderStatus == '68'){
        this.badDialogTitle = '不良件处理-退货'
      }
      if (this.problem.orderStatus == '82'){
        this.badDialogTitle = '不良件处理-部分销毁'
      }
      if (this.problem.orderStatus == '83'){
        this.badDialogTitle = '不良件处理-确认销毁'
      }
      this.badVisible =true;
    },
    async getDropDownList () {
      this.$http.post('/cms/logisticsCompany/getDropDownList').then(res => {
        this.LogisticsCompanyList = res.data.data;
      })
    },
    async getLocatorDropDownList() {
      const {data: res} = await this.$http.get("cms/locator/dropDownList");
      this.dropDownList = res.data;
    },
    changeTab(index){
      this.curIndex=index
      this.searchList()
    },
    async getBuyAccountIdList () {
      this.$http.get('cms/configAccountNumber/getAllList').then(res => {
        this.buyAcountList = res.data.data;
        this.buyAcountList.map(res => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case '0':
                return res.platformType_hanzi = '淘宝 -' + res.accountNumber
                break;
              case '1':
                return res.platformType_hanzi = '1688 -' + res.accountNumber
                break;
              case '2':
                return res.platformType_hanzi = '京东 -' + res.accountNumber
                break;
              case '3':
                return res.platformType_hanzi = '拼多多 -' + res.accountNumber
                break;
              case null:
                return res.platformType_hanzi = ''
                break;

            }
          }
        })
      })
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        // 接口start
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'staffProblem'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
                this.originColumns,
                result,
                "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this;
      // 接口
      let url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then(res => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: "保存成功",
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getProblemList();
          });
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          });
        }
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true;
    },
    toGoodsDetail(row){
      window.open(row.taobaoUrl,'_blank')
    },
    problemAll(data){       //查看处理说明列表
      this.$http.get('problem/handleLogList',{params:{id:data.id}}).then(res=>{
        this.items=res.data.data.reverse();
      })
      this.dialogVisible=true;
    },
    saveExplain(formName){                      //保存说明
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('problem/saveHandleLog',this.problemData).then(res=>{
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.addVisible=false;
              this.problemData={};
              this.getProblemCount();
              this.getProblemList();
            } else {
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },
    cancel(formName){                 //取消
      this.$refs[formName].clearValidate();       //取消警告提示
      this.addVisible = false;
    },
    addProblem(data){         //添加处理说明
      this.addVisible=true;
      this.problemData.problemId=data.id;
    },
    imgclick(url,visible){
      this.visible=true
      this.imgurl=url
    },
    formatDate(row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(newSize) {   //分页
      this.queryInfo.pageSize = newSize;
      this.getProblemCount();
      this.getProblemList();
    },
    handleCurrentChange(newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getProblemCount();
      this.getProblemList();
    },
    //不良件处理
    handleSave() {
      this.handleDeal(this.handleflag);
    },
    //正常发送
    sendSave() {
      this.sendDeal(this.handleflag)
    },
    clearReplyForm() {   //弹窗的取消按钮
      this.replyInfos.replyRemark = "";
      this.replyDialogVisible = false;
    },
    clearSendForm() { //正常发送弹窗的取消按钮
      this.sendDialogVisible = false;
    },
    async handleDeal(handleFlag) {    //处理不良件
      var my = this;
      my.replyInfos.handleType = handleFlag;
      this.$refs.replyInfoRef.validate(async function (valid) {
        if (valid) {
          var url = 'problem/handleProblem';
          const {data: res} = await my.$http.post(url, my.replyInfos);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
                my.replyDialogVisible = false;
            my.getProblemCount();
            my.getProblemList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    async sendDeal(flag) {    //正常发送
      var my = this;
      my.sendInfos.handleType = flag;
      var url = 'problem/sendNormally';
      const {data: res} = await my.$http.post(url, my.sendInfos);
      if (res.code == 200) {
        my.$message({
          type: 'success',
          message: res.message
        }),
            my.sendDialogVisible = false;
        my.getProblemCount();
        my.getProblemList();
      } else {
        my.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    searchList() {    //查询
      this.queryInfo.handleState = this.curIndex;
      this.queryInfo.pageNum = 1;
      this.getProblemCount();
      this.getProblemList();
    },
    async getProblemCount() {   //获取数量
      const {data: res} = await this.$http.get('problem/getStatisticalNum', {params: this.queryInfo});
      this.problemCount = res.data;
    },
    async getProblemList() {   //获取信息列表
      this.isLoading = true;
      const {data: res} = await this.$http.get('problem/list', {params: this.queryInfo});
      this.messageList = res.data.list;
      var _this = this;
      this.messageList.forEach(function (el) {
        if (el.problemUrl1 != null && el.problemUrl1 != "") {
          _this.$set(el, 'miniUrl1', el.problemUrl1 + '?x-oss-process=image/resize,m_fill,h_50,w_50');
        }
        if (el.problemUrl2 != null && el.problemUrl2 != "") {
          _this.$set(el, 'miniUrl2', el.problemUrl2 + '?x-oss-process=image/resize,m_fill,h_50,w_50');
        }
        if (el.problemUrl3 != null && el.problemUrl3 != "") {
          _this.$set(el, 'miniUrl3', el.problemUrl3 + '?x-oss-process=image/resize,m_fill,h_50,w_50');
        }
        if (el.pictureUrl != null && el.pictureUrl != "") {
          _this.$set(el, 'miniUrl4', el.pictureUrl + '?x-oss-process=image/resize,m_fill,h_50,w_50');
        }
      })
      this.total = res.data.total;
      this.isLoading = false;
    },
    queryInfoClear() {    //清空
        this.curIndex = ''
        this.queryInfo.handleState = '',
        this.queryInfo.userName = '',
        this.queryInfo.buyOrderNumber = ''
        this.queryInfo.customerName = ''
        this.queryInfo.handleType = ''
        this.queryInfo.orderNo = ''
        this.queryInfo.handleTimeStart = ''
        this.queryInfo.handleTimeEnd = ''
        this.queryInfo.waybillNumber = ''
        this.queryInfo.createTimeStart= '',
        this.queryInfo.createTimeEnd= '',
        this.queryInfo.orderId= '',
        this.queryInfo.returnWaybillNo = '',
        this.queryInfo.userName= '',
        this.queryInfo.pageSize= 5,
        this.queryInfo.pageNum= 1
        this.badDateRangeValue = [];
        this.problemDateRangeValue = [];
    },
    typeDetailShow(handleState) {
      switch (handleState) {
        case '1':
          return '待处理'
          break;
        case '2':
          return '处理中'
          break;
        case '3':
          return '处理完'
          break;
        case '4':
          return '已取消'
          break;
      }
    },
    handleTypeShow(handleType) {
      switch (handleType) {
        case '1':
          return '换货'
          break;
        case '2':
          return '补发'
          break;
        case '3':
          return '部分退货'
          break;
        case '4':
          return '全部退货'
          break;
        case '5':
          return '部分销毁'
          break;
        case '5':
          return '全部销毁'
          break;
        case '7':
          return '正常发送'
          break;
      }
    },
    //详情
    toProblemDetail(row) {
      this.$router.push({
        name: 'problemDetail',
        query: {
          id: row.id,
        }
      })
    },
    cannelBill(row,flag,type) {
      this.$confirm("确定要取消"+flag+"吗？",  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        row.handleType = type;
        const {data: res} = await this.$http.post(`problem/handleProblemCannel`, row);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "取消成功!"
          });
          await this.getProblemCount();
          await this.getProblemList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });
    },
    cancelStatus(row) {
      this.$confirm("确定要撤回吗？",  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const {data: res} = await this.$http.post(`problem/cancel`, row);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "撤回成功!"
          });
          await this.getProblemCount();
          await this.getProblemList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });
    },
    handle(row, flag) {     //不良处理
      this.handleflag = flag;
      this.replyDialogVisible = true;
      this.replyInfos = {
        id: '',
        exchangeCount: '',
        returnFee: '0',
        waybillNumber: '',
        reissueCount: '',
        returnCount: '',
        destroyCount: '',
      };
      if (flag == 1) {
        this.title = "换货";
        this.replyInfos.waybillNumber = row.waybillNumber;
        this.replyInfos.exchangeCount = row.count;
      } else if (flag == 2) {
        this.title = "补发";
        this.replyInfos.waybillNumber = row.waybillNumber;
        this.replyInfos.reissueCount = row.count;
      } else if (flag == 3) {
        this.$set(this.replyInfos,'returnAddress',row.returnAddress)
        // this.replyInfos.returnAddress = row.returnAddress
        this.title = "部分退货";
      } else if (flag == 5) {
        this.title = "部分销毁";
      }
      if (flag == 4) {
        this.$set(this.replyInfos,'returnAddress',row.returnAddress)
        this.replyInfos.returnCount = row.count;
        this.title = "全部退货";
      } else if (flag == 6) {
        this.replyInfos.destroyCount = row.count;
        this.title = "全部销毁";
      }
      this.replyInfos.id = row.id;
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.replyInfoRef.clearValidate();
      })

    },
    send(row) {     //正常发送
      this.sendDialogVisible = true;
      this.sendInfos.id = row.id;
      this.sendInfos.orderNo = row.orderNo;
    },
    async updateNotes(row, flag) {
      row.type = flag;
      var my = this;
      var url = 'problem/updateWaybillNo';
      const {data: res} = await my.$http.post(url, row);
      if (res.code == 200) {
        my.$message({
          type: 'success',
          message: res.message
        }),
            my.replyDialogVisible = false;
        my.getProblemCount();
        my.getProblemList();
      } else {
        my.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    replyDialogClose() {    //关闭回复弹窗
      this.replyDialogVisible = false;
    },
    sendDialogClose() {
      this.sendDialogVisible = false;
    },
    async exportAction(){
      this.$http({
        url: 'problem/exportAction',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res)=>{
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '不良件货库.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err)=>{
        // console.log(err);
      })
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    badDateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.badDateRangeValue) {
        this.badDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.badDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.badDateRangeValue[0] + " 00:00:00";
          this.queryInfo.createTimeEnd = this.badDateRangeValue[1] + " 23:59:59";
        }
      }
    },
    problemDateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.problemDateRangeValue) {
        this.problemDateRangeValue = [];
        this.queryInfo.handleTimeStart = '';
        this.queryInfo.handleTimeEnd = '';
      } else {
        if (this.problemDateRangeValue.length > 0) {
          this.queryInfo.handleTimeStart = this.problemDateRangeValue[0] + " 00:00:00";
          this.queryInfo.handleTimeEnd = this.problemDateRangeValue[1] + " 23:59:59";
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

.el-table {
  overflow: auto;
}
.commentDetail{
  margin-bottom: 20px;
}
.search-btn-container-status{
  text-align:left!important;
}

</style>
